module.exports = __webpack_public_path__ + "static/media/drone-port.0249d001.webp";